import { Criteria, BaseObject } from './metaobjects.types'

export function checkConditions(conditions: BaseObject, criteria: Criteria): boolean {
  const { tags = [], products = [], collections = [] } = criteria

  // Check date conditions only if they exist and have valid values
  const now = Date.now()

  if (conditions?.start_date && conditions.start_date.trim() !== '') {
    const startDate = new Date(conditions.start_date)
    if (!isNaN(startDate.getTime()) && now < startDate.getTime()) {
      return false
    }
  }

  if (conditions?.end_date && conditions.end_date.trim() !== '') {
    const endDate = new Date(conditions.end_date)
    if (!isNaN(endDate.getTime()) && now >= endDate.getTime()) {
      return false
    }
  }

  // Check if any selector conditions are specified
  const hasTagConditions = conditions?.tags && conditions.tags.length > 0
  const hasProductConditions = conditions?.products && conditions.products.length > 0
  const hasCollectionConditions = conditions?.collections && conditions.collections.length > 0

  // If no selector conditions are specified, don't include this metaobject
  if (!hasTagConditions && !hasProductConditions && !hasCollectionConditions) {
    return false
  }

  // Use OR logic like the PDP - if ANY condition matches, include the metaobject
  let hasMatch = false

  // Check collections if specified - must match
  if (hasCollectionConditions && conditions.collections) {
    const collectionMatch = conditions.collections.some(conditionCollection =>
      collections.some(criteriaCollection => conditionCollection === criteriaCollection)
    )
    if (collectionMatch) hasMatch = true
  }

  // Check products if specified - must match
  if (hasProductConditions && conditions.products) {
    const productMatch = conditions.products.some(conditionProduct =>
      products.some(criteriaProduct => conditionProduct === criteriaProduct)
    )
    if (productMatch) hasMatch = true
  }

  // Check tags if specified - must match
  if (hasTagConditions && conditions.tags) {
    const tagMatch = conditions.tags.some(conditionTag =>
      tags.some(criteriaTag => conditionTag === criteriaTag)
    )
    if (tagMatch) hasMatch = true
  }

  return hasMatch
}
